import { CarouselEventNavigationState } from 'src/domains/layouts/webview/components/eventNavigation/CarouselEventNavigationState';
import { computed, makeObservable } from 'mobx';
import { EventsCollectionQueryModel } from 'src_common/common/websocket2/models/EventsCollectionQueryModel';
import { OptionType, sortOptions } from 'src/domains/layouts/webview/components/eventNavigation/common';
import { EventsCollectionState } from 'src/domains/sportsbook/state/eventsCollection/EventsCollectionState';
import { Common } from 'src/domains/common/Common';

export class EventState {
    private readonly state: CarouselEventNavigationState;

    public constructor(
        state: CarouselEventNavigationState,
        private readonly common: Common
    ) {
        makeObservable(this);
        this.state = state;
    }

    @computed.struct private get collectionEvents(): EventsCollectionQueryModel | null {
        const page = this.state.pageType;

        if (page === null) {
            return null;
        }

        if (page.type === 'competition') {
            return EventsCollectionState.get(this.common)
                .listOfSportAndCompetition(page.sport, page.competition.toOldId())
                .getQuery();
        }

        if (page.type === 'event') {
            const event = this.state.event;

            if (event !== null) {
                return (
                    EventsCollectionState.get(this.common)
                        .listOfSportAndCompetition(event.sport, event.competition2.toOldId())
                        .getQuery() ?? null
                );
            }
        }

        return null;
    }

    @computed public get active(): string | null {
        const event = this.state.event;

        if (event !== null) {
            return event.id.toString();
        }

        return null;
    }

    @computed public get eventsData(): Array<OptionType> {
        const collectionEvents = this.collectionEvents;

        if (collectionEvents === null) {
            return [];
        }

        const list: Array<OptionType> = [];

        for (const event of collectionEvents.events) {
            list.push({
                value: event.id.toString(),
                sportId: undefined,
                label: event.name,
            });
        }

        list.sort(sortOptions);
        return list;
    }
}
